export default {"src":"/_next/static/media/StoreOrderability.aaeb27e3.svg","height":76,"width":76,"blurWidth":0,"blurHeight":0};